import React, { useEffect, useState, useRef } from "react";
import { FaShoppingCart, FaSearch, FaBars, FaTimes } from "react-icons/fa";
import { useCart } from "../../context/CartContext";
import { useLocation, useNavigate } from "react-router-dom";
import CartDropdown from "../CartDropdown/CartDropdown";
import tours from "../../API/tours";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTours, setFilteredTours] = useState([]);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const { cart } = useCart();
  const cartIconRef = useRef(null);
  const cartDropdownRef = useRef(null);
  const searchRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleCart = () => setIsCartOpen((prevState) => !prevState);

  // Handle input change and filter tours
  const handleSearchInput = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchTerm(query);

    if (query.length > 0) {
      const matches = tours.filter((tour) =>
        tour.name.toLowerCase().includes(query)
      );
      setFilteredTours(matches);
      setShowDropdown(matches.length > 0);
    } else {
      setFilteredTours([]);
      setShowDropdown(false);
    }
  };

  // Handle search submission
  const handleSearch = (e) => {
    e.preventDefault();
    if (filteredTours.length > 0) {
      navigateToTour(filteredTours[0]); // Navigate to the first match
    } else {
      alert("Tour not found. Please try again.");
    }
  };

  // Navigate when clicking on a suggestion
  const navigateToTour = (tour) => {
    const formattedName = tour.name.toLowerCase().replace(/\s+/g, "-");
    navigate(`/tours/${formattedName}`);
    window.scrollTo(0, 0);
    setSearchTerm(""); // Clear search input
    setFilteredTours([]); // Hide dropdown
    setShowDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        cartIconRef.current &&
        !cartIconRef.current.contains(event.target) &&
        cartDropdownRef.current &&
        !cartDropdownRef.current.contains(event.target)
      ) {
        setIsCartOpen(false);
      }

      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setTimeout(() => {
          setShowDropdown(false);
        }, 200);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 445);
      setIsCartOpen(false);
      setShowDropdown(false);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const hideCart =
    location.pathname === "/tours/book-now" ||
    location.pathname === "/tours/book-now/payment";

  return (
    <header className={isScrolled ? "scrolled" : ""}>
      <div className="top-bar">
        <div className="address">
          📍 Coron Palawan Philippines{" "}
          <a href="tel:+639066603788">| +63 906 660 3788</a>
        </div>
        <div className="actions">
          <form onSubmit={handleSearch} className="search-form" ref={searchRef}>
            <input
              type="text"
              placeholder="Search here..."
              value={searchTerm}
              onChange={handleSearchInput}
              onFocus={() => setShowDropdown(true)}
            />
            <button type="submit">
              <FaSearch />
            </button>
          </form>

          {showDropdown && filteredTours.length > 0 && (
            <ul className="search-dropdown">
              {filteredTours.map((tour) => (
                <li key={tour.name} onClick={() => navigateToTour(tour)}>
                  {tour.name}
                </li>
              ))}
            </ul>
          )}

          {!hideCart && (
            <div className="cart-icon" onClick={toggleCart} ref={cartIconRef}>
              <FaShoppingCart className="icon" />
              {cart.length > 0 && (
                <span className="cart-count">{cart.length}</span>
              )}
            </div>
          )}

          {isCartOpen && !hideCart && (
            <CartDropdown
              onClose={() => {
                setIsCartOpen(false); // Close the cart
                setTimeout(() => {}, 50); // Small delay to prevent UI race conditions
              }}
              ref={cartDropdownRef}
            />
          )}
        </div>
      </div>

      <div className="main-nav">
        <a href="/">
          <div className="left">
            <img src="/logo.jpg" alt="logo" loading="lazy"></img>
            <div className="logo">TwinTravelCoron</div>
          </div>
        </a>
        <nav className={isMenuOpen ? "nav-links open" : "nav-links"}>
          <ul>
            <a href="/">
              <li>Home</li>
            </a>
            <a href="/about-us">
              <li>About</li>
            </a>
            <a href="/tours">
              <li>Tours</li>
            </a>
            <a href="/contact-us">
              <li>Contact</li>
            </a>
          </ul>
        </nav>
        <div className="menu-icon" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </header>
  );
};

export default Header;
